import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(_ctx.iconClass ?? 'pay-method-icon'),
    loading: "lazy",
    onerror: "this.onerror=null; this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAAAAAA6fptVAAAADUlEQVR4nGP4////fwAJ+wP+J1iKsQAAAABJRU5ErkJggg==';",
    src: _ctx.helper.payMethodIcon(_ctx.method!),
    alt: _ctx.helper.trans('pay_methods.' + _ctx.method),
    title: _ctx.helper.trans('pay_methods.' + _ctx.method)
  }, null, 10, _hoisted_1)), [
    [
      _directive_b_tooltip,
      void 0,
      void 0,
      { hover: true }
    ]
  ])
}